import type { Session } from "next-auth";
import { getSession } from "next-auth/react";

/**
 *
 * @param session - The Session object from next-auth
 * @description This function checks if the session is valid and if the access token is still valid.
 *
 * If the session is valid and the access token is still valid, it returns the session.
 *
 * If the session is not valid or the access token is not valid, it tries to get a fresh session from the server.
 * @returns Session - The Session object from next-auth
 */
export const ensureActiveSession = async (session?: Session | null) => {
    if (session?.accessToken && session?.accessTokenExpiryTimestamp) {
        const now = new Date().getTime(); // Convert to seconds
        // Define a safe padding time to make sure we have time to execute API calls
        const timePadding = 30 * 1000; // 30 seconds in milliseconds
        const tokenExpiry = session.accessTokenExpiryTimestamp; // Expiry time to seconds
        const isFresh = tokenExpiry - now > timePadding;
        // If the token still has time left, return it.
        if (isFresh) {
            return session;
        }
    }
    // We can't reuse the session, so we need to generate a new one
    return await getSession();
};
